import { SITE_ORIGIN } from 'constants';
import routes from 'constants/routes';

export const GOODIE_TITLE = 'FOXI für Zahnarztpraxen | Danke für Ihren Besuch';

export const GOODIE_DESCRIPTION =
  'FOXI macht Dokumentation, Abrechnung, Anamnese, Termine und Recall für Zahnarztpraxen einfacher. Jetzt unverbindlich kennenlernen.';

export const GOODIE_URL = `${SITE_ORIGIN}${routes.goodie}`;

/**
 * Structured data for the goodie landing page. References the Organization,
 * WebSite and SoftwareApplication nodes that the start page defines (see
 * pages/HomeV2/seo.js) instead of duplicating them.
 */
export const goodieStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${GOODIE_URL}#webpage`,
  url: GOODIE_URL,
  name: GOODIE_TITLE,
  description: GOODIE_DESCRIPTION,
  inLanguage: 'de-DE',
  isPartOf: { '@id': `${SITE_ORIGIN}/#website` },
  about: { '@id': `${SITE_ORIGIN}/#software` },
  publisher: { '@id': `${SITE_ORIGIN}/#organization` },
};
